<adapt-activity-feed [promiseToGetInitialActivity]="promiseToGetInitialActivity"
                     [promiseToGetOlderActivity]="promiseToGetOlderActivity"
                     [promiseToGetNewerActivity]="promiseToGetNewerActivity"
                     emptyFeedText="There is no team activity to display"
                     [feedTitle]="feedTitle"></adapt-activity-feed>
